import { useState } from 'react';

import { PopoverAnchorPosition, PopoverOffset } from '@one/web-components';
import { t } from 'core/i18n/i18n';
import { TooltipedIconComponent } from '../tooltiped-icon';
import { PopoverMenuStyled } from './popover-menu.style';

export interface PopoverMenuComponentProps extends React.PropsWithChildren {
    anchor: string;
    position?: PopoverAnchorPosition;
    offset?: PopoverOffset;
    disableScroll?: boolean;
}

export const PopoverMenuComponent: React.FC<PopoverMenuComponentProps> = (props) => {
    const { anchor, children, position = 'left', offset, disableScroll = false } = props;
    const [visible, setVisible] = useState<boolean>(false);

    return (
        <>
            <TooltipedIconComponent
                anchor={anchor}
                icon="more_vertical"
                tooltipText={t('modules.operators.pods.operators-commands.more-functions.button')}
                family="outlined"
                onClick={(ev) => {
                    ev.stopPropagation();
                    setVisible((prev) => !prev);
                }}
                hideTooltip={visible}
            />
            <PopoverMenuStyled
                data-testid="popover-menu"
                anchor={anchor}
                trigger="click"
                offset={offset}
                position={position}
                $disableScroll={disableScroll}
                visible={visible}
                onVisibleChange={(ev) => setVisible(ev.detail)}
                onMouseLeave={() => setVisible(false)}
                onClick={(ev) => {
                    ev.stopPropagation();
                    setVisible(false);
                }}
            >
                {children}
            </PopoverMenuStyled>
        </>
    );
};
